{
  "it": {
    "question_list": {
      "actions": {
        "cancel": "Annulla",
        "cancelOrder": "Annulla",
        "delete": "Elimina",
        "deleteMultipleQuestionLists": "Elimina...",
        "delete_cancel": "Annulla",
        "edit": "Modifica",
        "new": "Elenco FAQ",
        "reorderQuestions": "Riordina domande",
        "save": "Salva",
        "saveOrder": "Salva ordine",
        "submit": "Crea",
        "tickBoxesDeletion": "Selezioni le caselle delle domande che desidera eliminare, quindi prema il pulsante in alto per confermare o annullare l'eliminazione."
      },
      "attributes": {
        "description": "Descrizione",
        "name": "Nome",
        "question_list": "FAQ"
      },
      "labels": {
        "allUnits": "Tutte le unità",
        "descriptionOptional": "Descrizione (facoltativa)",
        "editFAQ": "Modifica FAQ",
        "faq": "Domande frequenti",
        "faq_all_projects": "FAQ di tutti i progetti",
        "info": "Ha una domanda sulla Sua abitazione? Resti aggiornato sulle domande più frequenti e le relative risposte.",
        "questions": " Nessuna domanda | 1 domanda | {count} domande",
        "questions_count": "Domande",
        "showQuestionListFor": "Mostra le FAQ per",
        "title": "Domande frequenti"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Qui troverà le risposte alle domande generali o a quelle poste da altri.",
            "title": "Domande frequenti"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Fornisca le risposte alle domande generali che i Suoi clienti potrebbero avere.",
            "title": "Crei il Suo primo elenco FAQ"
          }
        }
      },
      "toasts": {
        "create": "Elenco FAQ creato",
        "delete": "Elenco FAQ eliminato",
        "update": "Elenco FAQ aggiornato"
      },
      "validation": {
        "needName": "Titolo obbligatorio",
        "selectQuestionList": "Selezioni almeno 1 elenco di domande"
      }
    }
  }
}
